var FormBuilderResetStateType = {
  Data: "data",
  ReadOnly: "readOnly"
};
var ListBuilderResetStateType = {
  Data: "data",
  Filters: "filters",
  Pagination: "pagination",
  Selection: "selection"
};

export { FormBuilderResetStateType, ListBuilderResetStateType };
